<!-- CP TEMPLATE -->
<div
   class="container-doc-fluid"
   [class.link]="item.context === 'link' || item.context === 'applink'"
   >
<div class="preview-wrap">
   <app-error *ngIf="errcode && errcode.code !== 3213" [errcode]="errcode"></app-error>
   <div *ngIf="spinner" class="preview-loading-wrap">
      <sync-spinner></sync-spinner>
   </div>
   <div class="doc-iframe-container" *ngIf="sessionId && !accusoftErr">
      <iframe
         class="preview-iframe"
         frameborder="0"
         id="sync-viewer"
         [src]="viewUrl"
         ></iframe>
   </div>
   <form [formGroup]="docForm" (ngSubmit)="submitPassword()">
   <div class="password-container" *ngIf="accusoftErr === 4001">
      <img src="./assets/images/protected.svg" />
      <app-error class="error-alert" *ngIf="errcode" [errcode]="errcode"></app-error>
      <div class="text">
         <div class="h5">Enter password</div>
         <div class="body-1 sub-text">This document is password protected. If you do not have the password, please contact the person who sent you this document.</div>
      </div>
      <sync-text-field
      class="text-field"
      label="Password"
      inputType="password"
      [inputChange]="onInputChange"
      formControlName="docPassword"
      [errorMessage]="invalidPasswordMsg"
      />
      <sync-button
      label="Submit"
      nativeType="submit"
      [disabled]="docForm.invalid"
      [isLoading]="passwordSpinner"
      size="large"
      />
   </div>
   </form>
</div>
<app-wopi-optin [openWopiOptinDialog]="isDisplayWOPI_Option" (optChange)="optChange($event)"></app-wopi-optin>